import React, { useContext } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import SignupProgress from "../../../Components/SignupProgress";
import { images } from "../../../Assets/images";

const CreateAccount3 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenThree,
    translatedLabels,
    logoUrl,
    is4Life,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const commonLabel = translatedLabels?.common;

  const handleSubmit = (e) => {
    e.preventDefault();
    createAccountScreenThree();
  };

  const servingOptions = ["0", "1", "2", "3", "4", "5+"];

  const questions = [
    {
      key: "fruits",
      icon: images.fruit,
      label:
        commonLabel?.fruits?.label_value ||
        "How many servings of fruit do you typically eat each day? (1 serving = ½ cup)",
    },
    {
      key: "vegetables",
      icon: images.vegetable,
      label:
        commonLabel?.vegetables?.label_value ||
        "How many servings of vegetables do you typically eat each day? (1 cup raw or ½ cup cooked)",
    },
    {
      key: "grains",
      icon: images.wholeGrain,
      label:
        commonLabel?.grains?.label_value ||
        "How many servings of whole grains do you typically eat each day? (Examples: ½ cup cooked rice or oatmeal, 1 slice whole wheat bread, or 1 cup whole grain cereal)",
    },
    {
      key: "sugaryFoods",
      icon: images.sugar,
      label:
        commonLabel?.sugaryFoods?.label_value ||
        "How many servings of sugary foods do you typically eat each day? (e.g., cookie, doughnut, cake)",
    },
    {
      key: "redMeat",
      icon: images.redMeat,
      label:
        commonLabel?.redMeat?.label_value ||
        "How many servings of red meat do you typically eat each week? (~3 oz, about the size of your palm)",
    },
    {
      key: "fish",
      icon: images.fish,
      label:
        commonLabel?.fish?.label_value ||
        "How many servings of fish do you typically eat each week? (~3 oz, about the size of your palm)",
    },
  ];

  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main h-auto">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <div className="content-card">
            <SignupProgress currentStep={is4Life ? 3 : null} />
            <h3 className="mb-4 text-center">
              {authLabel?.create_new_account?.label_value ||
                "Create new account"}
            </h3>
            <form className="login-form pt-0" onSubmit={handleSubmit}>
              <div className="row">
                {questions.map((question, qIndex) => (
                  <div className="mb-30px" key={qIndex}>
                    <div className="d-flex align-items-center gap-2">
                      <div className="input-image">
                        <img src={question.icon} alt="icon" />
                      </div>
                      <label className="form-label question-label">
                        {question.label} <span className="text-danger">*</span>
                      </label>
                    </div>

                    <select
                      className="form-select mt-1"
                      value={signupData?.[question.key] || ""}
                      onChange={(e) => updateSignupData(question.key, e.target.value)}
                    >
                      <option value="" disabled>
                        {authLabel?.select_option?.label_value || "Select Option"}
                      </option>
                      {servingOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>

              <div className="mb-30px">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div className="input-image">
                    <img src={images.activity} alt="activity" />
                  </div>
                  <label className="form-label question-label">
                    {commonLabel?.activity?.label_value ||
                      "How many minutes of moderate or vigorous physical activity do you get each week?(Moderate: breathing harder, can talk in short sentences. Vigorous: heavy breathing, few words at a time.)"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                </div>

                <select
                  className="form-select mt-1"
                  value={signupData?.activity || ""}
                  onChange={(e) => updateSignupData("activity", e.target.value)}
                >
                  <option value="" disabled>
                    {authLabel?.select_option?.label_value || "Select Option"}
                  </option>
                  {["Less than 50", "51 - 100", "101 - 150", "More than 150"].map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-4 text-center">
                <button type="submit" className="btn btn-primary">
                  {authLabel?.next?.label_value || "Next"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateAccount3;
